/* eslint-disable no-var */
/* eslint-disable no-console */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
/* eslint-disable quotes */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { utils } from "./utils";
export class personalInfo {
    static createNameValidation(errMsg, currentLocale) {
        utils.addValidationMethod("nameValid", (value, element) => {
            if (value === "" && !utils.isRequired(element)) {
                return true;
            }
            else {
                //to be compatible with IE9 placeholder workaround
                const nameRegex = new RegExp(/^[\p{L} ,.'-]*$/, "ui");
                return (value != "First Name" &&
                    value != "Last Name" &&
                    nameRegex.test(value));
            }
        }, errMsg[currentLocale].nameLetters);
    }
    static createEmailValidation(errMsg, currentLocale) {
        utils.addValidationMethod("emailValid", (value, element) => {
            //pattern takes the mask into account
            const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            const spam_pattern = new RegExp(/^test\d+@gmail\.com$/i);
            if (spam_pattern.test(value)) {
                return false;
            }
            if (value === "" && !utils.isRequired(element)) {
                return true;
            }
            else {
                return pattern.test(value);
            }
        }, errMsg[currentLocale].emailFormat);
    }
    static createZipcodeValidation(errMsg, currentLocale, locale) {
        switch (currentLocale) {
            case locale.enUS:
            case locale.esUS:
            case locale.esMX:
            case locale.esPE:
            case locale.esCO:
            case locale.esCL:
                utils.addValidationMethod("zipcodeUSValid", (value, element) => {
                    //pattern takes the mask into account
                    const pattern = new RegExp(/^\d{5}([-](_{4}|\d{4}))?$/);
                    if ((value === "" || value == "_____-____") &&
                        !utils.isRequired(element)) {
                        return true;
                    }
                    else if (!pattern.test(value)) {
                        return false;
                    }
                    return true;
                }, errMsg[currentLocale].zipFormat);
                break;
            case locale.esEC:
            case locale.esPY:
                utils.addValidationMethod("zipcodeECPYValid", (value, element) => {
                    //pattern takes the mask into account
                    const pattern = new RegExp(/^\d{6}([-](_{5}|\d{5}))?$/);
                    if ((value === "" || value == "_____-____") &&
                        !utils.isRequired(element)) {
                        return true;
                    }
                    else if (!pattern.test(value)) {
                        return false;
                    }
                    return true;
                }, errMsg[currentLocale].zipFormat);
                break;
            case locale.ptBR:
                utils.addValidationMethod("zipcodeBRValid", (value, element) => {
                    const pattern = new RegExp(/^\d{5}-?\d{3}$/);
                    if ((value === "" || value == "_____-___") &&
                        !utils.isRequired(element)) {
                        return true;
                    }
                    else if (!pattern.test(value)) {
                        return false;
                    }
                    return true;
                }, errMsg[currentLocale].zipFormat);
                break;
            case locale.enCA:
                utils.addValidationMethod("zipcodeCAValid", (value, element) => {
                    const pattern = new RegExp(/^[a-zA-Z]\d[a-zA-Z] \d[a-zA-Z]\d$/);
                    if ((value === "" || value == "___ ___") &&
                        !utils.isRequired(element)) {
                        return true;
                    }
                    else if (!pattern.test(value)) {
                        return false;
                    }
                    return true;
                }, errMsg[currentLocale].zipFormat);
                break;
        }
    }
    static createVinValidation(errMsg, currentLocale) {
        utils.addValidationMethod("vinValid", (value, element) => {
            const pattern = new RegExp(/^([ABCDEFGHJKLMNPRSTUVWXYZabcdefghjklmnprstuvwxyz]|[0-9]){17}$/);
            if (value === "" && !utils.isRequired(element)) {
                return true;
            }
            else {
                return pattern.test(value);
            }
        }, errMsg[currentLocale].vinFormat);
    }
    static createStateValidation(errMsg, currentLocale, locale, leads) {
        switch (currentLocale) {
            case locale.enUS:
            case locale.esUS:
            case locale.esCL:
                utils.addValidationMethod("stateValid", (value, element) => {
                    if ((value === "" || value === "__") &&
                        !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        return $.inArray(value.toUpperCase(), leads.states) > -1;
                    }
                }, errMsg[currentLocale].stateExist);
                break;
            case locale.enCA:
                utils.addValidationMethod("provinceValid", (value, element) => {
                    if ((value === "" || value === "__") &&
                        !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        return $.inArray(value.toUpperCase(), leads.provinces) > -1;
                    }
                }, errMsg[currentLocale].stateExist);
                break;
            case locale.esMX:
                utils.addValidationMethod("stateValid", (value, element) => {
                    if (value === "" && !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        return $.inArray(value.toUpperCase(), leads.statesMx) > -1;
                    }
                }, errMsg[currentLocale].stateExist);
                break;
            case locale.esCO:
                utils.addValidationMethod("departmentValid", (value, element) => {
                    if (value === "" && !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        return $.inArray(value.toUpperCase(), leads.departmentsCo) > -1;
                    }
                }, errMsg[currentLocale].stateExist);
                break;
            case locale.esPE:
                utils.addValidationMethod("stateValid", (value, element) => {
                    if ((value === "" || value === "__") &&
                        !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        return $.inArray(value.toUpperCase(), leads.statesPe) > -1;
                    }
                }, errMsg[currentLocale].stateExist);
                break;
            case locale.esEC:
                utils.addValidationMethod("stateValid", function (value, element) {
                    if (value === "" &&
                        !window.DealeronLead.isRequired(element)) {
                        return true;
                    }
                    else {
                        return ($.inArray(value.toUpperCase(), window.DealeronLead.statesEc) > -1);
                    }
                }, errMsg[currentLocale].stateExist);
                break;
            case locale.esPY:
                utils.addValidationMethod("stateValid", function (value, element) {
                    if (value === "" &&
                        !window.DealeronLead.isRequired(element)) {
                        return true;
                    }
                    else {
                        return ($.inArray(value.toUpperCase(), window.DealeronLead.statesPy) > -1);
                    }
                }, errMsg[currentLocale].stateExist);
                break;
            case locale.ptBR:
                utils.addValidationMethod("stateValid", (value, element) => {
                    if (value === "" && !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        return $.inArray(value.toUpperCase(), leads.statesBr) > -1;
                    }
                }, errMsg[currentLocale].stateExist);
                break;
        }
    }
    static createDateValidation(errMsg, currentLocale) {
        utils.addValidationMethod("dateValid", function (value, element) {
            return !$(element)
                .closest("div")
                .find(".combodate")
                .hasClass("combodateInvalid");
        }, errMsg[currentLocale].dateFormat);
    }
    static createFileValidation(errMsg, currentLocale, optional) {
        utils.addValidationMethod("fileValid", (value, element) => {
            let typeParam = element.hasAttribute("accept")
                ? element.getAttribute("accept").replace(/\s/g, "").replace(/,/g, "|")
                : "image/*";
            // Element is optional
            if (optional != null && optional(element)) {
                return true;
            }
            if ($(element).attr("type") === "file") {
                // make it regex friendly
                typeParam = typeParam.replace(/\./g, "\\.").replace(/\*/g, ".*");
                const regex = new RegExp("\\.?(" + typeParam + ")$", "i");
                if (element.files && element.files.length) {
                    for (let i = 0; i < element.files.length; i++) {
                        const file = element.files[i];
                        const fileext = file.name.lastIndexOf(".") == -1
                            ? ""
                            : file.name.substr(file.name.lastIndexOf("."));
                        if (!file.type.match(regex) && !fileext.match(regex)) {
                            return false;
                        }
                    }
                }
            }
            return true;
        }, errMsg[currentLocale].fileFormat);
    }
}
